import { useEffect, useRef } from 'react';
import { Monitor } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function PitchScreenShareStage({
  screenStream = null,
  speakerStream = null,
  speakerEnabled = false,
  speakerLoading = false,
  onShare,
}) {
  const screenRef = useRef(null);
  const speakerRef = useRef(null);

  useEffect(() => {
    const el = screenRef.current;
    if (!el) return undefined;
    el.srcObject = screenStream || null;
    if (screenStream) {
      el.play().catch(() => {});
    }
    return undefined;
  }, [screenStream]);

  useEffect(() => {
    const el = speakerRef.current;
    if (!el) return undefined;
    el.srcObject = speakerStream || null;
    if (speakerStream) {
      el.play().catch(() => {});
    }
    return undefined;
  }, [speakerStream]);

  const showSpeakerSlot = Boolean(speakerStream) || (speakerEnabled && speakerLoading && screenStream);

  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-xl border border-slate-700 bg-black">
      {screenStream ? (
        <video
          ref={screenRef}
          autoPlay
          muted
          playsInline
          className="h-full w-full object-contain"
        />
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center">
          <Monitor className="h-8 w-8 text-slate-500" />
          <p className="max-w-sm text-sm text-slate-400">
            Share a screen or window. The recording follows that display, and your microphone stays on the audio track.
          </p>
          {onShare ? (
            <Button type="button" variant="outline" className="gap-2" onClick={onShare}>
              <Monitor className="h-4 w-4" />
              Share screen
            </Button>
          ) : null}
        </div>
      )}

      {showSpeakerSlot ? (
        <div className="pointer-events-none absolute bottom-[4.5%] left-1/2 z-20 aspect-video w-[22%] min-w-[7.5rem] -translate-x-1/2 overflow-hidden rounded-xl border-2 border-white/85 bg-black shadow-[0_8px_24px_rgba(0,0,0,0.45)]">
          {speakerStream ? (
            <video
              ref={speakerRef}
              autoPlay
              muted
              playsInline
              className="h-full w-full object-cover"
              style={{ transform: 'scaleX(-1)' }}
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center px-2 text-center text-[10px] text-slate-400">
              Starting camera…
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
}

export default PitchScreenShareStage;
